import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { SeasonDTO } from "../dtos/SeasonDTO";
import { STALE_TIME_MEDIUM } from "../queries/query.constants";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
const SEASON_STALE_TIME = STALE_TIME_MEDIUM;
export function useSeasons() {
    const query = useQuery({
        queryKey: ["seasons"],
        queryFn: async () => (await seedgreenAPI.get("/v2/Season")).data,
        staleTime: SEASON_STALE_TIME,
        select: (data) => {
            try {
                return (data?.map((season) => new SeasonDTO(season)) ?? []);
            }
            catch (error) {
                console.error("query/seasons select ERROR", error);
            }
        },
    });
    return {
        seasons: query.data,
        ...query,
    };
}
export function useCreateSeason() {
    const queryClient = useQueryClient();
    const isAuthorized = useAuthorizedQuery();
    const query = useMutation({
        mutationFn: async (season) => {
            if (!isAuthorized.value)
                throw new Error("Not authorized");
            const response = await seedgreenAPI.post("/v2/Season", season);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["seasons"],
            });
        },
    });
    return {
        createSeason: query.mutateAsync,
        ...query,
    };
}
export function useUpdateSeason() {
    const queryClient = useQueryClient();
    const isAuthorized = useAuthorizedQuery();
    const query = useMutation({
        mutationFn: async ({ id, data, }) => {
            if (!isAuthorized.value)
                throw new Error("Not authorized");
            const response = await seedgreenAPI.put(`/v2/Season/${id}`, data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["seasons"],
            });
        },
    });
    return {
        updateSeason: query.mutateAsync,
        ...query,
    };
}
export function useDeleteSeason() {
    const queryClient = useQueryClient();
    const isAuthorized = useAuthorizedQuery();
    const query = useMutation({
        mutationFn: async (seasonId) => {
            if (!isAuthorized.value)
                throw new Error("Not authorized");
            const response = await seedgreenAPI.delete(`/v2/Season/${seasonId}`);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["seasons"],
            });
            queryClient.invalidateQueries({
                queryKey: ["harvest-overview-ranches"],
            });
            queryClient.invalidateQueries({
                queryKey: ["ranch-seasons"],
            });
        },
    });
    return {
        deleteSeason: query.mutateAsync,
        ...query,
    };
}
